import { format } from 'date-fns';
import { range } from 'lodash-es';
import { makeIntroVideoNone } from '~/models/intro-video';
import { COBStep } from './client-flow/clientOb/ClientOnboarding.utils';
import { makeManualApprovalMethodNoticePeriod } from './models/approval-method-notice-period/makers';
import { makeBillingDayOfMonthNotLast } from './models/BillingDayOfMonth';
import { makeExpirationDate } from './models/expiration-date';
import { RequestAccountantAccess } from './models/request-accountant-access';
import { StartBillingOnEnum } from './types/api.model';
export { openInNewTabProps } from 'seagull/utils/externalLinks';
export var HttpHeaders = /*#__PURE__*/ function(HttpHeaders) {
    HttpHeaders["SessionId"] = "Anchor-Session-Id";
    HttpHeaders["RequestId"] = "Anchor-Request-Id";
    HttpHeaders["ContentType"] = "Content-Type";
    return HttpHeaders;
}({});
export const redirect = {
    basePath: '/redirect',
    searchParams () {
        let { returnTo, initialSearch } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const params = new URLSearchParams(initialSearch);
        returnTo && params.set('returnTo', returnTo);
        return params;
    },
    getPathAndSearch () {
        let { returnTo } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return returnTo ? "".concat(this.basePath, "?").concat(new URLSearchParams({
            returnTo
        })) : this.basePath;
    },
    getReturnToFromSearch (locationSearch) {
        return new URLSearchParams(locationSearch).get('returnTo');
    }
};
const homeRoute = '/home';
const settingsRoute = homeRoute + '/settings';
const integrationsRoute = homeRoute + '/integrations';
const availableAppsRoute = integrationsRoute + '/available-apps';
const connectedAppsRoute = integrationsRoute + '/connected-apps';
const minisite = function minisite() {
    let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId';
    return "".concat(homeRoute, "/relationship/").concat(relationshipId);
};
const clientOnboarding = function clientOnboarding() {
    let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId', step = arguments.length > 1 ? arguments[1] : void 0;
    return "/engagement-letter/".concat(relationshipId).concat(step ? "/".concat(step) : '');
};
export const routes = {
    redirect: redirect.basePath,
    login: '/login',
    signUp: '/signup',
    setPassword: '/set-password',
    resetPassword: '/reset-password',
    allSet: function allSet() {
        let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId';
        return "/all-set/relationship/".concat(relationshipId);
    },
    notification: function notification() {
        let notificationId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':notificationId';
        return "/notification/".concat(notificationId);
    },
    notificationAction: "/notification-action",
    noAccessPage: '/no-access-page',
    home: homeRoute,
    acceptInvitation: '/accept-invitation',
    agreementStudio: '/agreement-studio',
    proposalTemplateStudio: '/proposal-template-studio',
    minisite,
    agreement: function agreement() {
        let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId';
        return minisite(relationshipId) + '/agreement';
    },
    invoices: function invoices() {
        let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId';
        return minisite(relationshipId) + '/invoices';
    },
    billingHub: function billingHub() {
        let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId';
        return minisite(relationshipId) + '/billing-hub';
    },
    activityLog: function activityLog() {
        let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId';
        return minisite(relationshipId) + '/activity';
    },
    paymentMethods: function paymentMethods() {
        let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId';
        return minisite(relationshipId) + '/payment-methods';
    },
    draft: function draft() {
        let draftId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':draftId';
        return "/draft/".concat(draftId);
    },
    proposalTemplate: function proposalTemplate() {
        let templateId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':templateId';
        return "/proposal-template/".concat(templateId);
    },
    clientOnboarding: clientOnboarding,
    clientOnboardingStepWelcome: (relationship)=>clientOnboarding(relationship, COBStep.welcome),
    clientOnboardingStepSelectAPackage: (relationship)=>clientOnboarding(relationship, COBStep.selectAPackage),
    clientOnboardingStepReviewServices: (relationship)=>clientOnboarding(relationship, COBStep.reviewServices),
    clientOnboardingStepApproveTerms: (relationship)=>clientOnboarding(relationship, COBStep.approveTerms),
    clientOnboardingStepAccountantAccess: (relationship)=>clientOnboarding(relationship, COBStep.accountantAccess),
    clientOnboardingStepPaymentMethod: (relationship)=>clientOnboarding(relationship, COBStep.paymentMethod),
    clientOnboardingStepIntroVideo: (relationship)=>clientOnboarding(relationship, COBStep.introVideo),
    clientOnboardingStepAllSet: (relationship)=>clientOnboarding(relationship, COBStep.allSet),
    expiredProposalPage: '/expired-proposal-page',
    canceledProposalPage: '/canceled-proposal-page',
    noPermissionsRelationshipAlreadyApproved: '/relationship-already-approved',
    allSignaturesAcquired: function allSignaturesAcquired() {
        let relationshipId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ':relationshipId';
        return "/all-signatures-acquired/".concat(relationshipId);
    },
    agreementsDashboard: homeRoute + '/agreements/signed',
    proposalsDashboard: homeRoute + '/agreements/pending',
    draftsDashboard: homeRoute + '/agreements/drafts',
    archivedProposals: homeRoute + '/agreements/archived',
    proposalTemplates: homeRoute + '/agreements/templates',
    proposalDefaults: homeRoute + '/agreements/defaults',
    invoicesDashboard: homeRoute + '/invoices',
    payoutsDashboard: homeRoute + '/payments',
    globalBillingHub: homeRoute + '/billing',
    availableApps: availableAppsRoute,
    connectedApps: connectedAppsRoute,
    serviceLibrary: homeRoute + '/services',
    bundlesLibrary: homeRoute + '/bundles',
    importServices: homeRoute + '/services/import',
    importContacts: homeRoute + '/contacts/import',
    importAgreements: homeRoute + '/agreements/import',
    anchorBilling: settingsRoute + '/billing',
    vendorDashboard: homeRoute + '/dashboard',
    team: settingsRoute + '/team',
    businessDetails: settingsRoute + '/businessdetails',
    profile: settingsRoute + '/profile',
    notifications: settingsRoute + '/notifications',
    qboSetup: availableAppsRoute + '/qbo',
    xeroSetup: availableAppsRoute + '/xero',
    slackIntegration: availableAppsRoute + '/slack',
    hubspotIntegration: availableAppsRoute + '/hubspot',
    financialCentsSetup: availableAppsRoute + '/financial-cents',
    karbonSetup: availableAppsRoute + '/karbon',
    clientHubSetup: availableAppsRoute + '/client-hub',
    keeperSetup: availableAppsRoute + '/keeper',
    contacts: homeRoute + '/contacts',
    referrals: homeRoute + '/referrals',
    kyb: '/kyb-verification',
    logout: '/logout',
    loginError: '/email-diff-from-origin',
    reports: homeRoute + '/reports',
    revenueReport: homeRoute + '/reports/revenue',
    activeServicesReport: homeRoute + '/reports/active-services',
    remainingCreditReport: homeRoute + '/reports/remaining-credit',
    futureInvoicesReport: homeRoute + '/reports/future-invoices',
    proposalsReport: homeRoute + '/reports/sent-proposals',
    additionalPaymentProcessorInfo: '/additional-payment-processor-info',
    anchorApiKeys: integrationsRoute + '/api-keys',
    activityLogs: homeRoute + '/activity-logs'
};
export const defaultAuthorizedRoute = (isVendor)=>isVendor ? routes.vendorDashboard : routes.agreementsDashboard;
export const daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
export const defaultBillingDayOfWeek = 'Monday';
export const repeatableManualBillingDayOfMonth = 1;
export const getDefaultBillingDayOfYear = ()=>({
        month: 1,
        day: 1
    });
/** Must be a non-leap year so the date picker never shows February 29. */ export const BILLING_DAY_OF_YEAR_REFERENCE_YEAR = 2001;
export function formatDayOfYear(dayOfYear) {
    return format(new Date(BILLING_DAY_OF_YEAR_REFERENCE_YEAR, dayOfYear.month - 1, dayOfYear.day), 'MMMM d');
}
export const netTermsOptions = range(91);
export const ownershipTypes = [
    {
        value: 'soleProprietorship',
        display: 'Sole proprietorship'
    },
    {
        value: 'partnership',
        display: 'Partnership'
    },
    {
        value: 'llc',
        display: 'LLC'
    },
    {
        value: 'corporation',
        display: 'Corporation'
    }
];
// The list of states was taken from here: https://www.infoplease.com/us/postal-information/state-abbreviations-and-state-postal-codes
export const states = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY'
];
export const templatePlaceholders = {
    clientFirstName: '{first_name}',
    vendorBusinessName: '{business_name}'
};
export const businessSettingsDefaults = {
    legalTermsDocumentId: '',
    disablePlaidLink: false,
    netTerms: 0,
    billingDayOfMonth: makeBillingDayOfMonthNotLast(1),
    billingDayOfWeek: defaultBillingDayOfWeek,
    feeControls: {
        coverCreditCardFees: false,
        coverDirectDebitFees: false
    },
    amendmentsApprovalMethod: makeManualApprovalMethodNoticePeriod(),
    invoicesApprovalMethod: makeManualApprovalMethodNoticePeriod(),
    billUpfront: false,
    automaticServicesPausedByDefault: false,
    prorateFirstInvoice: false,
    requestAccountantAccess: RequestAccountantAccess.None,
    introductoryMessages: {
        invitation: "Hi ".concat(templatePlaceholders.clientFirstName, ",\n        We at ").concat(templatePlaceholders.vendorBusinessName, " are upgrading to Anchor, a new billing platform.\n\n        As a result, our agreement, services, pricing, and discounts can all be viewed in one centralized place, so you have full visibility at all times. Paying with Anchor is secure, hassle-free, and fully controlled by you.\n\n        It takes only three minutes to review and approve our agreement through Anchor."),
        proposal: "Hi ".concat(templatePlaceholders.clientFirstName, ",\n        As discussed, the agreement is ready for your review and approval.\n\n        Please click the link below to review the agreement through Anchor, our billing platform.\n\n        Paying with Anchor is secure, hassle-free, and fully controlled by you. Our agreement, services, pricing, and discounts can all be viewed in one centralized place, so you have full visibility at all times.")
    },
    startBillingOn: StartBillingOnEnum.SkipBillingOnAcceptance,
    introVideo: makeIntroVideoNone(),
    invoiceLineItems: 'grouped',
    expirationDate: makeExpirationDate(),
    invoicePrefix: 'ANC'
};
export const positiveQuantityInputProps = {
    min: 0,
    step: 'any'
};
export const emptyCell = {
    value: null
};
export const defaultAgreementTitle = 'Untitled agreement';
export const anchorCdnUrl = 'https://cdn.anchor.sh';
export var SlackUserGroups = /*#__PURE__*/ function(SlackUserGroups) {
    SlackUserGroups["ProductTeam"] = "<!subteam^S04FHKU667K|product-team>";
    return SlackUserGroups;
}({});
export var UtmParams = /*#__PURE__*/ function(UtmParams) {
    /** Received when clicking on a referral link from the referral dashboard. */ UtmParams["Referral"] = "utm_ref";
    /** V2 referral link — awards $100 credit instead of $50. Sent when REFERRAL_DASHBOARD_UPGRADE FF is on. */ UtmParams["ReferralV2"] = "utm_ref_v2";
    return UtmParams;
}({});
export var ErrorText = /*#__PURE__*/ function(ErrorText) {
    ErrorText["UnexpectedErrorTryAgain"] = "An unexpected error occurred. Please try again";
    ErrorText["MismatchingRelationshipVersion"] = "The agreement has been updated. Please refresh the page and try again.";
    ErrorText["ProposalAlreadyAcceptedOrCanceled"] = "The proposal was already accepted or canceled";
    ErrorText["IntegrationDataRetrieval"] = "We couldn't load data. Please verify your connection on the Integrations page and try again.";
    return ErrorText;
}({});
export var RecurrenceFilterValue = /*#__PURE__*/ function(RecurrenceFilterValue) {
    RecurrenceFilterValue["OneTime"] = "oneTime";
    RecurrenceFilterValue["Weekly"] = "weekly";
    RecurrenceFilterValue["Biweekly"] = "biweekly";
    RecurrenceFilterValue["Monthly"] = "monthly";
    RecurrenceFilterValue["Quarterly"] = "quarterly";
    RecurrenceFilterValue["Yearly"] = "yearly";
    RecurrenceFilterValue["OnDemand"] = "onDemand";
    return RecurrenceFilterValue;
}({});
export const recurrencePeriodLabels = {
    ["oneTime"]: 'One time',
    ["weekly"]: 'Weekly',
    ["biweekly"]: 'Every two weeks',
    ["monthly"]: 'Monthly',
    ["quarterly"]: 'Quarterly',
    ["yearly"]: 'Yearly',
    ["onDemand"]: 'On demand'
};
export function getRecurrenceFilterOptions() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.entries(recurrencePeriodLabels).filter((param)=>{
        let [value] = param;
        return options.onDemand || value !== "onDemand";
    }).map((param)=>{
        let [value, label] = param;
        return {
            value: value,
            label
        };
    });
}
export const getMobileTheme = ()=>({
        '--font-size-h1': '36px',
        '--font-size-h2': '28px',
        '--font-size-h3': '24px',
        '--font-size-h4': '20px',
        '--font-size-h5': '18px',
        '--font-size-h6': '14px',
        '--font-size-p1': '12px',
        '--font-size-p2': '10px',
        '--font-size-p3': '10px',
        '--line-height-h1': '52px',
        '--line-height-h2': '36px',
        '--line-height-h3': '34px',
        '--line-height-h4': '32px',
        '--line-height-h5': '30px',
        '--line-height-h6': '22px',
        '--line-height-p1': '16px',
        '--line-height-p2': '14px',
        '--line-height-p3': '14px'
    });
